import { moduleIdProp, routeStoreLenses } from 'root/src/client/logic/route/lenses'
import {
	formModuleLenses,
} from 'root/src/client/logic/form/lenses'

import moduleDescriptions from 'root/src/shared/descriptions/modules'
import myProfileSelector from 'root/src/client/logic/route/selectors/myProfileSelector'

const { viewRoute } = routeStoreLenses

const { viewCancelButton } = formModuleLenses

// TODO @next - it currently doesn't works like it should for some of pages.
//   we need to add previous route handling
export default (state, props) => {
	const cancelButton = viewCancelButton(
		moduleIdProp(props), moduleDescriptions,
	)

	if (!cancelButton) {
		return null
	}

	let cancelRoute
	if (cancelButton.route) {
		const { recordId, routeId } = cancelButton.route(state) || {}
		cancelRoute = recordId
			? { routeId, routeParams: { recordId } } : undefined
	}

	return {
		...cancelButton,
		...(cancelRoute || viewRoute(state) || myProfileSelector(state)),
	}
}
